import React from 'react';
import { Alerts, Assets, Findings, Identities, Incidents, Risk360, Threats } from '@fabric-ui/icons/app-icons';
import AlertsFull from '@fabric-ui/icons/svg/apps/AlertsFull.svg';
import AssetsFull from '@fabric-ui/icons/svg/apps/AssetsFull.svg';
import FindingsFull from '@fabric-ui/icons/svg/apps/FindingsFull.svg';
import IdentitiesFull from '@fabric-ui/icons/svg/apps/IdentitiesFull.svg';
import IncidentsFull from '@fabric-ui/icons/svg/apps/IncidentsFull.svg';
import Risk360Full from '@fabric-ui/icons/svg/apps/Risk360Full.svg';
import ThreatsFull from '@fabric-ui/icons/svg/apps/ThreatsFull.svg';
import { APP_PATHS } from '../../types';
import { App } from '../../types/sideBar.types';

export const appsOptions: App[] = [
  {
    id: APP_PATHS.VULNERABILITIES,
    name: 'Vulnerabilities',
    description: 'Unified Vulnerability Management',
    icon: <Findings />,
    imageFull: FindingsFull,
    iconFull: <img src={FindingsFull} alt="Vulnerabilities" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.yellow,
    enumValue: 'VULNERABILITIES',
  },
  {
    id: APP_PATHS.DETECTIONS,
    name: 'Detections',
    description: 'Event Detections',
    icon: <Alerts />,
    imageFull: AlertsFull,
    iconFull: <img src={AlertsFull} alt="Detections" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.orange,
    enumValue: 'DETECTIONS',
  },
  {
    id: APP_PATHS.INCIDENTS,
    name: 'Incidents',
    description: 'Incident Management',
    icon: <Incidents />,
    imageFull: IncidentsFull,
    iconFull: <img src={IncidentsFull} alt="Incidents" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.purple,
    enumValue: 'INCIDENTS',
  },
  {
    id: APP_PATHS.RISK360,
    name: 'Risk360',
    description: 'Risk360',
    icon: <Risk360 />,
    imageFull: Risk360Full,
    iconFull: <img src={Risk360Full} alt="Risk360" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.primary,
    enumValue: 'RISK360',
  },
  {
    id: APP_PATHS.ASSETS,
    name: 'Assets',
    description: 'Asset Exposure Management',
    icon: <Assets />,
    imageFull: AssetsFull,
    iconFull: <img src={AssetsFull} alt="ASSETS" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.blue,
    enumValue: 'ASSETS',
  },
  {
    id: APP_PATHS.THREATS,
    name: 'Threats',
    description: 'Threats App',
    icon: <Threats />,
    imageFull: ThreatsFull,
    iconFull: <img src={ThreatsFull} alt="Threats" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.purple,
    enumValue: 'THREATS',
  },
  {
    id: APP_PATHS.IDENTITIES,
    name: 'Identities',
    description: 'Identities App',
    icon: <Identities />,
    imageFull: IdentitiesFull,
    iconFull: <img src={IdentitiesFull} alt="Identities" style={{ width: 24, height: 24 }} />,
    backgroundColor: theme => theme.palette.gradients.pink,
    enumValue: 'IDENTITIES',
  },
];
